import { useContext } from "react";
import { Helmet } from "react-helmet-async";

import { CookieConsentContext } from "./CookieConsentContext";

// Add tracking scripts conditionally based on cookie consent
// Matomo tracking is handled in PageWrapper.js with useMatomo hook
export function Tracking() {
  const { optionAllowed } = useContext(CookieConsentContext);

  return (
    <Helmet>
      {optionAllowed("facebook") && <script async src="/facebook.js" />}
      {optionAllowed("tiktok") && <script async src="/tiktok.js" />}
    </Helmet>
  );
}
